export default __webpack_public_path__ + "static/media/baby-29.1fd0ac43.svg";